<header>
  <nav class="navbar navbar-expand-xl fixed-top navbar-light bg-white bg-light" >
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="/">
        <div class="logo-corporativo">
          <img src="assets/fake/fondo-transparente.png" width="180" height="66"
            alt="Logo Niterra México" class="logo-placeholder">
        </div>
      </a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse nav-menu " id="collapsibleNavbar">

      <div class="margin-left-auto" >
        <ul class="navbar-nav mx-auto bg-white nav-bar-body" >
          <li class="nav-item "[routerLinkActive]="['active']" *ngFor="let menu of about_menu">
            <a class="nav-link nav-link-item" *ngIf="menu.subMenu.length == 0 && menu.textkey" routerLink="{{menu.url.url}}"
                data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
              <span *ngIf="sel_lang=='english'">{{menu.textkey.english.toUpperCase()}}</span>
              <span *ngIf="sel_lang=='spanish'">{{menu.textkey.spanish.toUpperCase()}}</span>
            </a>
            <a class="nav-link nav-link-item dropdown-toggle" *ngIf="menu.subMenu.length && menu.textkey"
              routerLink="{{menu.url.url}}" role="button" data-bs-toggle="dropdown">
              <span *ngIf="sel_lang=='english'">{{menu.textkey.english.toUpperCase()}}</span>
              <span *ngIf="sel_lang=='spanish'">{{menu.textkey.spanish.toUpperCase()}}</span>
            </a>
            <ul class='dropdown-menu sub-menu'  *ngIf="menu.subMenu.length>0">
              <li class="about-submenu dropdown-item col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                *ngFor="let item of menu.subMenu;index as i">
                <a class="dropdown-item" *ngIf="item.subMenu.length == 0 && item.textkey" routerLink="{{item.url.url}}"
                  data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                  <img *ngIf="item.icon && item.icon.url" class="small-nav-icon" src="{{item.icon.url}}" alt="repaire icon" />
                  <span *ngIf="sel_lang=='english'">{{item.textkey.english.toUpperCase()}}</span>
                  <span *ngIf="sel_lang=='spanish'">{{item.textkey.spanish.toUpperCase()}}</span>
                </a>

                <a class="dropdown-item dropdown-toggle" *ngIf="item.subMenu.length>0" (mouseover)="hoverIn(i)" routerLink="{{item.url.url}}"
                   role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <img *ngIf="item.icon && item.icon.url" class="small-nav-icon" src="{{item.icon.url}}" alt="repaire icon" />
                  <span *ngIf="sel_lang=='english'">{{item.textkey.english.toUpperCase()}}</span>
                  <span *ngIf="sel_lang=='spanish'">{{item.textkey.spanish.toUpperCase()}}</span>
                </a>

                <ul class='dropdown-menu sub-menu1 show'  *ngIf="item.subMenu.length>0 && sub_menu_state==i+1"
                  (mouseleave)="hoverOut(i)">
                  <li class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                    *ngFor="let item1 of item.subMenu">

                    <a class="dropdown-item" (click)="onRedirect(item1.url.url)" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
                      <img *ngIf="item1.icon && item1.icon.url" class="small-nav-icon" src="{{item1.icon.url}}" alt="repaire icon" />
                      <span *ngIf="sel_lang=='english'">{{item1.textkey.english.toUpperCase()}}</span>
                      <span *ngIf="sel_lang=='spanish'">{{item1.textkey.spanish.toUpperCase()}}</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
      <div class="collapse h-menu" id="">
        <ul class="navbar-nav mx-auto search-nav" >
          <li *ngIf="showLang" class="lang-selelction">
            <select class="language-sel" (change)="onChangeLang($event, true)" [(ngModel)]="sel_lang">
              <option value="spanish">ESP</option>
              <option value="english">ENG</option>
            </select>
          </li>
        <!---->
          <li class="nav-item d-flex search-nav-list">
            <ng-container *ngFor="let item of icon_menu">
              <a *ngIf="item && item.url" class="social-link" title="{{ item.name }}" href="{{ item.url }}" target="_blank"
                rel="noopener noreferrer">
                <div class="nav-social-icon">
                  <img class="social-nav-icon" [src]="item.icon.url" [alt]="item.name || 'Ícono de red social'" />
                </div>
              </a>
          
              <!-- Fallback si no hay URL -->
              <span *ngIf="!item?.url" class="nav-social-icon-disabled">
                <img class="social-nav-icon" [src]="item.icon.url" [alt]="item.name || 'Ícono sin enlace'" />
              </span>
            </ng-container>
          </li>          
          <li class="nav-item ">
            <form #formSearchWeb>
              <input class="nav-search" placeholder="Search in web"  autocomplete="off" (keyup.enter)="onNavSearchChange($event)" *ngIf="sel_lang=='english'"/>
              <input class="nav-search" placeholder="Búsqueda en la web"  autocomplete="off" (keyup.enter)="onNavSearchChange($event)" *ngIf="sel_lang=='spanish'"/>
            </form>
          </li>
        </ul>
      </div>
      </div>
      <div class="part-finder-div"></div>
      <div class=" col-xs-6 col-sm-1.5">
      <button class="part-found-btn " data-bs-toggle="collapse" data-bs-target="#nav-search" (click)="onClose($event)" >
        <img class="repair-icon"
          src="assets/params/images/icons/Vector.png" alt="repaire icon"
          align="left"
          data-canonical-src="assets/params/images/icons/Vector.png" /><h6 #btnPartFinder>#TitlePartFinderAPP#</h6></button>
    </div>
    </div>
    <div class="search-modal-collapse collapse" id="nav-search">
      <div class="container">
        <div class="">
          <button class="text-red" data-bs-toggle="collapse" data-bs-target="#nav-search" (click)="onClose($event)">X</button>
        </div>
        <div class="btn-group btn-group-sm btn-group-border container col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <button [ngClass]="statusvehiclemotor" type="button" class="btn btn-init btn-group-border-first" (click)="onFindClick(0)"  (click)="setActivestatusvehiclemotor()" #butPFVehicle>#PartFinderbtnVehicle#</button>
          <button [ngClass]="statuspartnumber" type="button" class="btn btn-init"(click)="onFindClick(1)"  (click)="setActivestatuspartnumber()" #butPFPNumber>#PartFinderbtnStock#</button>
          <button [ngClass]="statuscroosreference" type="button" class="btn btn-init btn-group-border-last"(click)="onFindClick(2)" (click)="setActivestatuscroosreference()" #butPFCReference>#PartFinderbtnReference#</button>
          </div>
        <div class="input-group mb-3 part-finder-search-div container col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="sel_lang=='english'">
          <input type="text" [(ngModel)]="find_input_text" value="" autocomplete="off" (keyup.enter)="onInputEnter($event)" (keyup)="onChange($event)"
            class="form-control part-finder-search-input col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            placeholder="Search">
          <div class="input-group-append">
            <img class="part-finder-search-img" src="assets/params/images/icons/Vector@2x.png">
          </div>
        </div>
        <div class="input-group mb-3 part-finder-search-div container col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf="sel_lang=='spanish'">
          <input type="text" [(ngModel)]="find_input_text" value="" autocomplete="off" (keyup.enter)="onInputEnter($event)" (keyup)="onChange($event)"
            class="form-control part-finder-search-input col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
            placeholder="Buscar">
          <div class="input-group-append">
            <img class="part-finder-search-img" src="assets/params/images/icons/Vector@2x.png">
          </div>
        </div>

        <div class="container text-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="display: flex;">
          <h6 class="modal-text" style="position: relative;" #h6Partfindercontent>#PartFinderDescription#</h6>
          <div class="search-result" *ngIf="find_list.length>0">
            <div>
              <ul *ngFor="let item of find_list" >
                <p style="background-color: #eeeeee;font-size:14px">{{item.foundin}}: </p>
                <li  class="search-result-li" *ngFor="let item1 of item.vehicle" (click)="onClickSearchList(item1.idproduct)"
                data-bs-toggle="collapse" data-bs-target="#nav-search">{{item1.vehicleDescription}}</li>
              </ul>
            </div>
          </div>
          <div class="search-result" *ngIf="find_list1.length>0">
            <div>
              <ul *ngFor="let item of find_list1" >
                <p style="background-color: #eeeeee;font-size:14px">{{item.type}}:</p>
                <li class="search-result-li" *ngFor="let item1 of item.partNumbers" (click)="onClickSearchList(item1.idproduct)"
                data-bs-toggle="collapse" data-bs-target="#nav-search">{{item1.lineproduct}} ({{item1.partnumber}})</li>
              </ul>
            </div>
          </div>
          <div class="search-result" *ngIf="find_list2.length>0">
            <app-tree [value]="find_list2" (seleccion)="onClickSearchList($event)"></app-tree>
            <!-- <div>
              <ul >
                <li class="search-result-li" *ngFor="let item of find_list2" (click)="onClickSearchList(item.idproduct)"
                data-bs-toggle="collapse" data-bs-target="#nav-search">{{item.partnumber}}</li>
              </ul>
            </div> -->
          </div>
          <div class="search-result" *ngIf="find_list.length==0 && checkProsses && sel_lang=='spanish' && findBtnState == 0 ">
            <div>
              <ul >
                <p style="background-color: #eeeeee;font-size:14px">No tengo resultados de la búsqueda </p>
              </ul>
            </div>
          </div>
          <div class="search-result" *ngIf="find_list.length==0 && checkProsses && sel_lang=='english' && findBtnState == 0">
            <div>
              <ul >
                <p style="background-color: #eeeeee;font-size:14px">No items were found matching your search</p>
              </ul>
            </div>
          </div>

          <div class="search-result" *ngIf="find_list.length1==0 && checkProsses && sel_lang=='spanish' && findBtnState == 1 ">
            <div>
              <ul >
                <p style="background-color: #eeeeee;font-size:14px">No tengo resultados de la búsqueda </p>
              </ul>
            </div>
          </div>
          <div class="search-result" *ngIf="find_list.length1==0 && checkProsses && sel_lang=='english' && findBtnState == 1">
            <div>
              <ul >
                <p style="background-color: #eeeeee;font-size:14px">No items were found matching your search </p>
              </ul>
            </div>
          </div>

          <div class="search-result" *ngIf="find_list.length2==0 && checkProsses && sel_lang=='spanish' && findBtnState == 2 ">
            <div>
              <ul >
                <p style="background-color: #eeeeee;font-size:14px">No tengo resultados de la búsqueda </p>
              </ul>
            </div>
          </div>
          <div class="search-result" *ngIf="find_list.length2==0 && checkProsses && sel_lang=='english' && findBtnState == 2">
            <div>
              <ul >
                <p style="background-color: #eeeeee;font-size:14px">No items were found matching your search</p>
              </ul>
            </div>
          </div>


        </div>

        <div class="container text-center col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <h6 class="modal-text2" #h6Partfindercontents>#PartFinderDescription2#</h6>
        </div>
        <div class="">
          <!-- offset-->
          <button class="btn d-flex modal-btn center-btn-search" style="font-size:120%;" routerLink="/part-finder" data-bs-toggle="collapse" data-bs-target="#nav-search" #h6SearchbyCategory>#PartFinderButtonDescription#</button>
        </div>
      </div>
    </div>
  </nav>
</header>
<div class="main-body width-100-p" >
  <router-outlet></router-outlet>
</div>

<div class="footer bg-dark" >
  <div class="row container mx-auto col-11 col-sm-11 col-md-11 col-lg-11 col-xl-11">
    <div class="container col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3"*ngFor="let item of footer_text_menu; index as i">
      <div class="d-flex footer-text-title">
        <img class="footer-image footer-image-first" [src]="printImageFooter(item.icon)"  alt="Ícono Niterra México">
          <div *ngIf="sel_lang=='english'" class="text-white fotter-text1" >{{item.titlekey.english}}</div>
          <div *ngIf="sel_lang=='spanish'" class="text-white fotter-text1" >{{item.titlekey.spanish}}</div>
      </div>
      <div *ngIf="item.isSocialMedia==false">
        <div *ngFor="let item1 of item.children" >
          <div *ngIf="item1.url" style="margin-left: 20px;">
            <a class="text-white footer-text "  *ngIf="sel_lang=='english' && item1.url?.url" [href]="item1.url.url" (click)="validateURL(item1.url.url)">{{item1.contentkey.english}}</a>
            <a class="text-white footer-text "  *ngIf="sel_lang=='spanish' && item1.url?.url" [href]="item1.url.url" (click)="validateURL(item1.url.url)">{{item1.contentkey.spanish}}</a>
          </div>
          <div *ngIf="item1.file" style="margin-left: 20px;">
            <a class="text-white footer-text "  *ngIf="sel_lang=='english' && item1.file?.url" [href]="item1.file.url" (click)="validateURL(item1.file.url)">{{item1.contentkey.english}}</a>
            <a class="text-white footer-text "  *ngIf="sel_lang=='spanish' && item1.file?.url" [href]="item1.file.url" (click)="validateURL(item1.file.url)">{{item1.contentkey.spanish}}</a>
          </div>
          <div *ngIf="!item1.url && !item1.file">
            <p class="text-white footer-text footer-text-p" *ngIf="sel_lang=='english'" >{{item1.contentkey.english}}</p>
            <p class="text-white footer-text footer-text-p " *ngIf="sel_lang=='spanish'">{{item1.contentkey.spanish}}</p>
          </div>
        </div>
      </div>
      <div *ngIf="item.isSocialMedia" class="d-flex" style="margin-bottom: 23px;">
          <ng-container *ngFor="let item1 of item.children">
            <a *ngIf="item1 && item1.url && item1.url !== ''" class="social-link" title="{{ item1.name }}" href="{{ item1.url }}"
              target="_blank" rel="noopener noreferrer">
              <div class="nav-social-icon">
                <img class="social-nav-icon" [src]="item1.icon.url" [alt]="item1.name || 'Ícono de red social'" />
              </div>
            </a>
              <!-- Fallback visual si falta URL -->
              <span *ngIf="!item1?.url" class="nav-social-icon-disabled">
                <img class="social-nav-icon" [src]="item1.icon.url" [alt]="item1.name || 'Ícono sin enlace'" />
              </span>
           </ng-container>
      </div>
    </div>

  </div>

</div>
<div class="bg-black text-white text-center" >
  <h6 class="footer-text2">© 2023 Niterra México S.A. de C.V. Todos los derechos reservados.</h6>
</div>


